import React from 'react';
import styles from './selectedContent.module.scss';
import Actions from './actions/Actions';
import { SllModule } from '@types';

type Props = {
  isFullScreen: boolean;
  isPreview?: boolean;
  content: SllModule;
  goBack?: () => void;
};

function DefaultContent({ content, isFullScreen, isPreview, goBack }: Props) {
  return (
    <Actions fullScreen={isFullScreen} isPreview={isPreview} goBack={goBack}>
      <div className={`${styles.content} ${styles.centerText}`}>
        {/* <h2 style={{ color: isFullScreen || isPreview ? 'black' : 'white' }}>
          {`${content.name}`}
        </h2> */}
      </div>
    </Actions>
  );
}

export default DefaultContent;
